import * as types from "../constants/ActionTypes";
import { INITIAL_STATE } from "../constants/AppConstants";

const srmRecordReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_SRM_RECORD:
      return Object.assign({}, state, Object.assign({}, state, action.payload));
    default:
      return state;
  }
};

export default srmRecordReducer;
